<template>
    <div class="EntityFunctions ">
        <Section
            #default="{ data, execute, isResolving, isRejected }"
            :endpoint="`entities.${entityKey}`"
        >
            <WCard :loading="isResolving">
                <ListFunctions
                    v-if="!isRejected"
                    :data="data.data"
                    class="pt-1 pb-1"
                />
                <WText
                    v-else-if="isRejected"
                    visible
                >
                    {{ $t('actions.retry.text') }}
                    <a @click="execute">{{ $t('actions.retry.link') }}</a>
                </WText>
            </WCard>
        </Section>
    </div>
</template>

<script>
import VueTypes from 'vue-types'
import { Section } from '@/components'
import { ListFunctions } from './components'

export default {
    name: 'EntityFunctions',
    components: {
        Section,
        ListFunctions,
    },
    props: {
        entityKey: VueTypes.string,
    },
}
</script>
